import { Link } from 'react-router'

import type { ZoneSnapshot, ZoneTransfer } from '../api'
import { Pill } from '../components'
import { bytes, dt, num, statusKind } from '../format'

export function TransfersTable({ rows }: { rows: ZoneTransfer[] }) {
  return (
    <table className="tbl">
      <thead>
        <tr>
          <th>Zone</th><th>Checked</th><th>Outcome</th><th>Serial</th><th className="num">Records</th>
          <th className="num">Size</th><th className="num">Time</th><th>Run</th><th>Error</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((t, i) => (
          <tr key={`${t.zone}-${t.checked_at}-${i}`}>
            <td className="mono">.{t.zone}</td>
            <td>{dt(t.checked_at)}</td>
            <td><Pill kind={statusKind(t.outcome)}>{t.outcome.replace('_', ' ')}</Pill></td>
            <td className="mono">{t.soa_serial ?? '–'}</td>
            <td className="num">{num(t.records)}</td>
            <td className="num">{bytes(t.bytes)}</td>
            <td className="num">{t.duration_ms === null ? '–' : `${(t.duration_ms / 1000).toFixed(1)} s`}</td>
            <td>{t.run_id ? <Link to={`/runs/${t.run_id}`} className="mono">#{t.run_id}</Link> : '–'}</td>
            <td className="err-t">{t.error}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export function SnapshotsTable({ rows }: { rows: ZoneSnapshot[] }) {
  return (
    <table className="tbl">
      <thead>
        <tr>
          <th>Zone</th><th>Serial</th><th>Fetched</th><th className="num">Domains</th><th className="num">Added</th>
          <th className="num">Removed</th><th className="num">NS changed</th><th className="num">DNSSEC changed</th><th>Snapshot</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((s) => (
          <tr key={`${s.zone}-${s.serial}`}>
            <td className="mono">.{s.zone}</td>
            <td className="mono">{s.serial}</td>
            <td>{dt(s.fetched_at)}</td>
            <td className="num">{num(s.domains)}</td>
            {s.events.baseline ? (
              <td colSpan={4} className="muted">baseline (first snapshot, no diff)</td>
            ) : (
              <>
                <td className="num">{num(s.events.added)}</td>
                <td className="num">{num(s.events.removed)}</td>
                <td className="num">{num(s.events.changed_ns)}</td>
                <td className="num">{num(s.events.changed_dnssec)}</td>
              </>
            )}
            <td className="mono muted">{s.snapshot_deleted_at ? 'deleted by retention' : s.snapshot_key}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
